import { useState } from 'react'

import { useSelector } from 'react-redux'

import useAgencyProvider from '@hooks/useAgencyProvider'
import useAgencyPublication from '@hooks/useAgencyPublication'

const useCreateAgencyPublicationsModal = (initAgencyPublication) => {
  const { agency_id } = initAgencyPublication

  const [selectedPublicationIds, setSelectedPublicationIds] = useState([])

  const publications = useSelector(reduxState => reduxState.entities.publications)

  const selectedPublications = selectedPublicationIds
    .map(id => publications[id])
    .filter(publication => publication)

  const hasSelectedPublications = !!selectedPublications.length

  const {
    agency,
    callbacks: {
      bulkCreateAgencyPublications,
    },
    creating,
  } = useAgencyPublication(initAgencyPublication)

  const {
    callbacks: { createOrEditAgencyProvider },
  } = useAgencyProvider({ agency_id })

  return {
    agency,
    callbacks: {
      bulkCreateAgencyPublications,
      createOrEditAgencyProvider,
      setSelectedPublicationIds,
    },
    creating,
    hasSelectedPublications,
    publications,
    selectedPublicationIds,
    selectedPublications,
  }
}

export default useCreateAgencyPublicationsModal
